import { Navigate, useSearchParams } from 'react-router-dom';
import { getSearchDestination } from '../../explorer/searchNavigation';

function ExplorerRedirect() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  const destination = query ? getSearchDestination(query) : '/';

  return <Navigate to={destination || '/'} replace />;
}

export default ExplorerRedirect;
